import facetApi from './facetApi';

const init = (initialState) => {
  const api = facetApi(initialState);

  // Expose API
  const facetApiHandler = {
    instance(instanceId) {
      const instance = this.instances.filter((inst) => inst.id === instanceId);
      return instance ? instance[0] : null;
    },
    addInstance(instanceId, apiInstance) {
      if (!this.instance(instanceId)) {
        this.instances.push({
          id: instanceId,
          api: apiInstance,
        });
      }
    },
    instances: [],
  };
  window.agGridFacetApi = window.agGridFacetApi || facetApiHandler;
  window.agGridFacetApi.addInstance(initialState.agGridInstanceId, api);
  return api;
};

export default init;
